import httpService from '@Utils/httpService';

const baseUrl = 'api/documents';

/** Document versions API (DOCUMENT_VERSIONS_UI_PLAN.md section 1). */
export default {
  /** Page<DocumentVersionVM>, newest first. itemsPerPage is capped at 100 by the API. */
  getVersions(documentId, { page = 1, itemsPerPage = 20 } = {}) {
    return httpService.get({
      url: `${baseUrl}/${documentId}/versions`,
      params: { page, itemsPerPage },
    });
  },

  /** Page<DocumentVersionEventVM>, newest first. */
  getHistory(documentId, { page = 1, itemsPerPage = 50 } = {}) {
    return httpService.get({
      url: `${baseUrl}/${documentId}/history`,
      params: { page, itemsPerPage },
    });
  },

  /** Pins a version as current. Returns the DocumentVM; 409 when rowVersion is stale. */
  setCurrent(documentId, revisionId, rowVersion) {
    return httpService.put({
      url: `${baseUrl}/${documentId}/current-version`,
      data: { revisionId, rowVersion: rowVersion || null },
    });
  },

  /** Clears the pin; the highest version becomes current. Returns the DocumentVM. */
  clearCurrent(documentId, rowVersion) {
    return httpService.delete({
      url: `${baseUrl}/${documentId}/current-version`,
      params: rowVersion ? { rowVersion } : {},
    });
  },

  /** The version's bytes through the authenticated proxy. Resolves to a Blob. */
  fetchVersionBlob(documentId, revisionId) {
    return httpService
      .get({
        url: `${baseUrl}/${documentId}/versions/${revisionId}/view`,
        responseType: 'blob',
      })
      .then((res) => res.data);
  },

  /**
   * Which names are already taken in the facility or facility group. Resolves to one
   * DocumentNameConflictVM per item, in order.
   * @param {{ assetId?: string, facilityGroupId?: string, items: Array<{ key, documentNumber, documentTitle, fileName }> }} body
   */
  checkNames(body) {
    return httpService.post({
      url: `${baseUrl}/check-names`,
      data: body,
    });
  },

  /** Stored bytes of document versions for a facility or a facility group. */
  getStorage({ assetId = null, facilityGroupId = null } = {}) {
    return httpService.get({
      url: `${baseUrl}/storage`,
      params: { assetId, facilityGroupId },
    });
  },

  /**
   * Links placed on one version (default: the current one). Links are per version; when adding a
   * new version, ask whether to transfer them if this is above zero.
   * Resolves to { documentId, revisionId, versionNumber, linkCount }.
   */
  getLinkCount(documentId, revisionId = null) {
    return httpService
      .get({
        url: `${baseUrl}/${documentId}/link-count`,
        params: { revisionId },
      })
      .then((res) => res.data);
  },
};
